<div
  role="alert"
  class="alert w-100 alert-danger"
  *ngIf="invalidCredentials$ | async"
>
  <strong>{{ 'admin.alerts.headerError' | translate }}</strong>
  {{ 'admin.alerts.invalidCredentials' | translate }}
</div>
<form [formGroup]="loginForm" class="pb-0 pt-4">
  <div class="col-lg-12">
    <div class="row">
      <div class="col-md-12">
        <app-form-row
          layout="auth-prompt"
          label="admin.passwordAuth.passAuthPromt"
        ></app-form-row>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <app-form-row
          label="admin.global.email"
          labelFor="username"
          layout="address"
          [required]="true"
        >
          <app-input-text
            [bare]="true"
            inputType="text"
            autocomplete="username"
            [isDisabled]="true"
            [control]="username"
          ></app-input-text>
        </app-form-row>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <app-form-row
          label="admin.global.password"
          labelFor="password"
          layout="address"
          inputClass="input-group"
          [required]="true"
        >
          <app-input-text
            [bare]="true"
            inputType="password"
            autocomplete="current-password"
            [maxLength]="100"
            testId="user-auth-password"
            [control]="password"
          ></app-input-text>
        </app-form-row>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <app-button
        type="button"
        variant="primary"
        dataTestid="password-auth-submit-button"
        (click)="loginAction()"
        [disabled]="loginForm.invalid"
      >
        {{ 'admin.passwordAuth.passAuthButton' | translate }}
      </app-button>
    </div>
  </div>
</form>
